




















































































import { Component } from "vue-property-decorator";
import PaginationComponent from "@/components/new_style_components/PaginationComponent.vue";
import Application from "@/state/Application";
import PRILService from "@/services/request/PRILService";
import { processError } from "@/utils/ComponentUtils";
import Short_PRIL_DTO from "@/dto/request/pril/Short_PRIL_DTO";
import PRILExtension from "@/mixins/PRILExtension";
import moment from "moment";
import {Direction} from "@/dto/request/pril/PRIL_DTO";

@Component({
  components: {
    PaginationComponent,
  },
  computed: {
    moment() {
      return moment
    }
  }
})
export default class PostalListCustomer extends PRILExtension {
  private totalPages = 1;
  private filter = { pageNumber: 1, pageSize: 20 };
  private postalList: Array<Short_PRIL_DTO> = [];
  private selectedDirection: Direction | null = null;

  async mounted(): Promise<void> {
    await this.loadPostalList();
  }

  loadPostalList(): void {
    Application.startLoading();
    const filterWithDirection = { ...this.filter, direction: this.selectedDirection };
    PRILService.getLettersByCustomerId(this.$wss.getCurrent.id, filterWithDirection).then(
      resp => {
        this.postalList = resp.data.content;
        this.totalPages = resp.data.totalPages;
        Application.stopLoading();
      },
      error => processError(error, this)
    )
  }

  changePage(page: number): void {
    this.filter.pageNumber = page;
    this.loadPostalList();
  }

  setDirection(direction: Direction | null): void {
    this.selectedDirection = direction;
    this.filter.pageNumber = 1;
    this.loadPostalList();
  }
}
